import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

export default function Header(props) {
  return (
    <Fragment>
      <h3
        style={
          props.style !== undefined
            ? props.style
            : {
              textTransform: 'uppercase',
              marginBottom: '0',
              color: 'dimgrey',
              fontWeight: 'bold',
              fontSize: '22px'
            }
        }
        className="card-title"
        data-testid='Header'>
        {props.title}
      </h3>
    </Fragment>
  );
}

Header.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  title: PropTypes.string,
};
